import cn from 'classnames'
import Link from 'next/link'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'

interface NormalLinkProps {
  additionalProps?: Record<string, string>
  additionalClasses?: string
  href: string
  text: string
}

export function NormalLink ({ href, text, additionalClasses, additionalProps }: NormalLinkProps): ReactElement {
  const { siteTheme: { buttonColors } } = useSnapshot(proxyGlobalAuth)
  return (
    <Link href={href}>
      <div
        className={
          cn(buttonColors.secondaryClasses, 'cursor-pointer', additionalClasses)
        }
        {...additionalProps}
      >
        {text}
      </div>
    </Link>
  )
}

NormalLink.defaultProps = {
  additionalProps: {}
}
